import { DatePicker, Table } from 'antd';
import dayjs from 'dayjs';
import { keyBy, merge, values } from 'lodash';
import React, { Component } from 'react';
import BookingApi from '../../../functions/api/booking/BookingApi';
import TableUtils from '../../../functions/TableUtils';
import ButtonFormatter from './ButtonFormatter';
import { columnTitles, TABLE } from './columns';

const { RangePicker } = DatePicker;

class ListBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listBooking: [],
      isLoading: false,
      filteredInfo: TableUtils.getFilterFromUrl(),
    };
  }

  activeFormatter = (cell, row) => {
    return (
      <ButtonFormatter
        cell={cell}
        row={row}
        onChangeList={this.handleChangeList}
      />
    );
  };

  formatDate = (dateValue) => {
    if (dateValue === null || dateValue === undefined) {
      return null;
    }
    return (
      <>
        {dayjs(dateValue).format('HH:mm')}
        <br />
        {dayjs(dateValue).format('D/M/YYYY')}
      </>
    );
  };

  getColumnDateFilter = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <DatePicker
          autoFocus
          format="ll"
          onChange={(selected) => {
            setSelectedKeys([selected]);
            confirm();
          }}
        />
      ),
      onFilter: (value, record) => {
        if (!value) {
          return true;
        }

        const recordDateValue = dayjs(record[dataIndex]);
        if (!recordDateValue.isValid()) {
          return false;
        }
        return recordDateValue.isSame(value, 'day');
      },
    };
  };

  getColumnDateRangeFilter = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <RangePicker
          onChange={(selected) => {
            setSelectedKeys([selected]);
            confirm();
          }}
          autoFocus
          format="ll"
        />
      ),
      onFilter: (value, record) => {
        if (!value) {
          return true;
        }

        let [start, end] = value;

        if (!start || !end) {
          return true;
        }

        const recordDateValue = dayjs(record[dataIndex]);
        if (!recordDateValue.isValid()) {
          return false;
        }
        return recordDateValue.isBetween(start, end, 'day', '[]');
      },
    };
  };

  async componentDidMount() {
    await this.getBookingForPartner();

    this.setState({ isLoading: false });
  }

  getBookingForPartner = async () => {
    const { part_id } = this.props;

    this.setState({ isLoading: true });

    const listBooking = await BookingApi.getListForPart(part_id);

    this.setState({
      listBooking,
      currentTotal: listBooking.length,
      isLoading: false,
      currentDataSource: listBooking,
    });
  };

  handleChangeList = (list) => {
    this.setState({ listBooking: list });
  };

  getColumnConfig = (filteredInfo) => {
    const { listBooking } = this.state;

    const columnConfigs = [
      {
        dataIndex: 'book_code',
        key: 'book_code',
        fixed: 'left',
        filteredValue: filteredInfo.book_code || null,
        ...TableUtils.getColumnSearchProps('book_code'),
      },
      {
        dataIndex: 'cstm_name',
        key: 'cstm_name',
        render: this.renderCustomerInfo,
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('cstm_name'),
        filteredValue: filteredInfo.cstm_name || null,
      },
      {
        dataIndex: 'book_crta',
        key: 'book_crta',
        render: this.formatDate,
        align: 'right',
        ...this.getColumnDateFilter('book_crta'),
        filteredValue: filteredInfo.book_crta || null,
        sorter: (a, b) => dayjs(a.book_crta).diff(dayjs(b.book_crta), 's'),
      },
      {
        dataIndex: 'book_rental_date_actual',
        render: this.formatDate,
        className: 'text-primary',
        align: 'right',
        ...this.getColumnDateRangeFilter('book_rental_date_actual'),
        filteredValue: filteredInfo.book_rental_date_actual || null,
        sorter: (a, b) =>
          dayjs(a.book_rental_date_actual).diff(
            dayjs(b.book_rental_date_actual),
            's'
          ),
      },
      {
        dataIndex: 'book_return_date_actual',
        render: this.formatDate,
        align: 'right',
        ...this.getColumnDateFilter('book_return_date_actual'),
        filteredValue: filteredInfo.book_return_date_actual || null,
      },
      {
        dataIndex: 'vhc_type_name',
        key: 'vhc_type_name',
        ...TableUtils.getColumnDropDownFilter(listBooking, 'vhc_type_name'),
        filteredValue: filteredInfo.vhc_type_name || null,
      },

      {
        dataIndex: 'book_prie_tota',
        key: 'book_prie_tota',
        render: this.renderBookingTotal,
        align: 'right',
        filteredValue: filteredInfo.book_prie_tota || null,
      },
      {
        dataIndex: 'detail',
        key: 'detail',
        align: 'right',
        render: this.activeFormatter,
      },
    ];

    const titles = columnTitles.filter((t) => t.hideOn !== TABLE.BACKEND);

    // merge titles with configs
    const mergeKey = 'dataIndex';
    return values(
      merge(keyBy(titles, mergeKey), keyBy(columnConfigs, mergeKey))
    );
  };

  render() {
    const { listBooking, currentTotal, filteredInfo } = this.state;

    const columns = this.getColumnConfig(filteredInfo);

    return (
      <>
        <h1>Đơn đặt</h1>
        <Table
          rowKey="book_id"
          size="small"
          columns={columns}
          dataSource={listBooking}
          scroll={{ x: 'max-content' }}
          onChange={this.tableSourceDidChange}
          title={() => `Tổng số: ${currentTotal}`}
          rowClassName={(record, index) =>
            record.part_id === null &&
            record.part_id_actual === null &&
            'text-danger'
          }
        />
      </>
    );
  }
}

export default ListBooking;
